import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = ["צהרונים", "חוגי העשרה", "ספורט וכושר", "אומנויות ובמה", "חיות וטכנולוגיה", "בית ספר מעיינות"];
  return (
    <div className="py-8 md:py-12 border-y border-ink/10 bg-paper">
      <Marquee speed={38} autoFill gradient={false} direction="right">
        {items.map((t, i) => (
          <span key={i} className="mx-8 md:mx-14 inline-flex items-center gap-8 md:gap-14">
            <span className="font-head font-black text-4xl md:text-7xl outline-text tracking-tight">{t}</span>
            <span className="w-2.5 h-2.5 rounded-full bg-accent" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
